import Vue from 'vue'
import VueRouter from 'vue-router'
import isAuthenticatedGuard from './auth-guard'
import loginGuard from './login-guard'

Vue.use(VueRouter)

  const routes = [
    { path: "/", 
      redirect: "login" 
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: loginGuard,
      component: () => import('../views/Login.vue'),
      meta: { hideNavbar: true }
    },
    {
      path: '/account',
      name: 'recovery-account',
      component: () => import('../views/RecoveryAccount.vue'),
      meta: { hideNavbar: true }
    },
    {
      path: '/password/:token',
      name: 'change-password',
      component: () => import('../views/ChangePassword.vue'),
      meta: { hideNavbar: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      beforeEnter: isAuthenticatedGuard,
      component: () => import('../views/Dashboard.vue')
    },
    {
      path: '/invoice-details/:id?',
      name: 'invoice-details',
      beforeEnter: isAuthenticatedGuard,
      component: () => import('../views/InvoiceDetails.vue')
    },
    { 
      path: '/:pathMatch(.*)*', 
      name: 'NotFound',
      meta: { hideNavbar: true }, 
      component: () => import('../views/NotFound')
    },
]

const router = new VueRouter({
  mode: '',
  routes
})

export default router
